import { useState } from 'react';
import FullScreenModalWrapper from 'src/components/FullScreenModalWrapper';
import { DepositClose } from 'src/components/svg/Crosses';
import { useModalContext } from 'src/hooks/useModalContext';
import { Tabs } from './components/Tabs';
import { SearchingGames } from './components/SearchingGames';
import { SearchingProviders } from './components/SearchingProviders';
import { SearchingStateTabs } from './types';

export const SearchModal = () => {
  const { modalProps, closeModal } = useModalContext<{
    searchTab: SearchingStateTabs;
  }>();
  const [currentSearching, setCurrentSearching] = useState<SearchingStateTabs>(
    modalProps.searchTab || 'games'
  );

  return (
    <FullScreenModalWrapper className="bg-sm_bg">
      <DepositClose
        className="absolute top-0 right-0 cursor-pointer z-[20] box-content pt-4 px-5"
        onClick={closeModal}
      />
      <div className="flex flex-col mt-10 gap-y-3">
        <Tabs currentSearching={currentSearching} setCurrentSearching={setCurrentSearching} />
        {currentSearching === 'games' ? <SearchingGames /> : <SearchingProviders />}
      </div>
    </FullScreenModalWrapper>
  );
};
